import { render, staticRenderFns } from "./reconciliation.vue?vue&type=template&id=480e89d2&scoped=true&"
import script from "./reconciliation.vue?vue&type=script&lang=js&"
export * from "./reconciliation.vue?vue&type=script&lang=js&"
import style0 from "./reconciliation.vue?vue&type=style&index=0&id=480e89d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e89d2",
  null
  
)

export default component.exports